module.exports = __webpack_public_path__ + "static/media/SearchEvent.9d437d38.svg";